import React, {ReactElement} from "react";

import {ImageObject} from "../../image/Image";
import {CTA} from "../../buttons/cta-button/CTAButton";
import FastFact from "../../cards/fast-fact/FastFact";
import ModuleBody from "../../layouts/module-body/ModuleBody";

import * as styles from "./fast-facts-columns.module.scss";

export interface FastFactsColumnsProps {
  leftBgImage?: ImageObject;
  leftLogo?: ImageObject;
  leftEyebrow?: string;
  leftHeadline?: string;
  leftHeadlineTrailing?: string;
  leftCopy?: string;
  leftBodyCopy?: {leftBodyCopy: string};
  leftCta?: CTA;
  leftCaption?: string;
  middleBgImage?: ImageObject;
  middleLogo?: ImageObject;
  middleEyebrow?: string;
  middleHeadline?: string;
  middleHeadlineTrailing?: string;
  middleCopy?: string;
  middleBodyCopy?: {middleBodyCopy: string};
  middleCta?: CTA;
  middleCaption?: string;
  rightBgImage?: ImageObject;
  rightLogo?: ImageObject;
  rightEyebrow?: string;
  rightHeadline?: string;
  rightHeadlineTrailing?: string;
  rightCopy?: string;
  rightBodyCopy?: {rightBodyCopy: string};
  rightCta?: CTA;
  rightCaption?: string;
}

const FastFactsColumns = (props: FastFactsColumnsProps): ReactElement => {
  const {
    leftBgImage,
    leftLogo,
    leftEyebrow,
    leftHeadline,
    leftHeadlineTrailing,
    leftCopy,
    leftBodyCopy,
    leftCta,
    leftCaption,
    middleBgImage,
    middleLogo,
    middleEyebrow,
    middleHeadline,
    middleHeadlineTrailing,
    middleCopy,
    middleBodyCopy,
    middleCta,
    middleCaption,
    rightBgImage,
    rightLogo,
    rightEyebrow,
    rightHeadline,
    rightHeadlineTrailing,
    rightCopy,
    rightBodyCopy,
    rightCta,
    rightCaption,
  } = props;

  const leftCopyContent = leftCopy || leftBodyCopy?.leftBodyCopy!;
  const middleCopyContent = middleCopy || middleBodyCopy?.middleBodyCopy!;
  const rightCopyContent = rightCopy || rightBodyCopy?.rightBodyCopy!;

  const hasLeftContent =
    leftBgImage ||
    leftLogo ||
    leftEyebrow ||
    leftHeadline ||
    leftHeadlineTrailing ||
    leftCopy ||
    leftBodyCopy ||
    leftCta ||
    leftCaption;

  const hasMiddleContent =
    middleBgImage ||
    middleLogo ||
    middleEyebrow ||
    middleHeadline ||
    middleHeadlineTrailing ||
    middleCopy ||
    middleBodyCopy ||
    middleCta ||
    middleCaption;

  const hasRightContent =
    rightBgImage ||
    rightLogo ||
    rightEyebrow ||
    rightHeadline ||
    rightHeadlineTrailing ||
    rightCopy ||
    rightBodyCopy ||
    rightCta ||
    rightCaption;

  return (
    <section className={styles.fastFactsColumns}>
      <ModuleBody classes={styles.fastFactsColumns__body}>
        {hasLeftContent && (
          <div className={styles.fastFactsColumns__item}>
            <FastFact
              bgImage={leftBgImage}
              eyebrow={leftEyebrow}
              headline={leftHeadline}
              trailing={leftHeadlineTrailing}
              copy={leftCopyContent}
              caption={leftCaption}
              cta={leftCta}
              logo={leftLogo}
            />
          </div>
        )}

        {hasMiddleContent && (
          <div className={styles.fastFactsColumns__item}>
            <FastFact
              classes={styles.fastFactsColumns__cardEven}
              bgImage={middleBgImage}
              eyebrow={middleEyebrow}
              headline={middleHeadline}
              trailing={middleHeadlineTrailing}
              copy={middleCopyContent}
              caption={middleCaption}
              cta={middleCta}
              logo={middleLogo}
            />
          </div>
        )}

        {hasRightContent && (
          <div className={styles.fastFactsColumns__item}>
            <FastFact
              bgImage={rightBgImage}
              eyebrow={rightEyebrow}
              headline={rightHeadline}
              trailing={rightHeadlineTrailing}
              copy={rightCopyContent}
              caption={rightCaption}
              cta={rightCta}
              logo={rightLogo}
            />
          </div>
        )}
      </ModuleBody>
    </section>
  );
};

export default FastFactsColumns;
